export const addCurrentProductsGroupProduct = `mutation ($data: prodigio_product_physical_groups_products_physical_insert_input!) {
    item: insert_prodigio_product_physical_groups_products_physical_one(object: $data) {
      physical_product {
        id
        name
      }
    }
  }
  `;
